export const STAGES = [
  { value: "new_lead", label: "New Lead", color: "bg-white/5 text-slate-300 border-white/15", dot: "bg-slate-400" },
  { value: "follow_up_book", label: "Follow-up · Book Call", color: "bg-amber-500/15 text-amber-300 border-amber-500/30", dot: "bg-amber-400" },
  { value: "call_scheduled", label: "Call Scheduled", color: "bg-blue-500/15 text-blue-300 border-blue-500/40", dot: "bg-blue-400" },
  { value: "follow_up_close", label: "Follow-up · Close", color: "bg-teal-500/15 text-teal-300 border-teal-500/30", dot: "bg-teal-400" },
  { value: "closed_lost", label: "Closed Lost", color: "bg-rose-500/15 text-rose-300 border-rose-500/30", dot: "bg-rose-400" },
  { value: "closed_won", label: "Closed Won", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30", dot: "bg-emerald-400" },
];

export const stageMeta = (value) => STAGES.find((s) => s.value === value) || STAGES[0];

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);
